import React from "react";
import { Button, Grid } from "@mui/material";
import SortIcon from "@mui/icons-material/Sort";
import SearchIcon from "@mui/icons-material/Search";
import MicIcon from "@mui/icons-material/Mic";
import CreateIcon from "@mui/icons-material/Create";
import DeleteIcon from "@mui/icons-material/Delete";
import { useNavigate } from "react-router-dom";
import Zoom from "react-medium-image-zoom";
// import Switch from "@mui/material/Switch";

// For Modal
import Dialog from "@mui/material/Dialog";
// import DialogActions from "@mui/material/DialogActions";
import DialogContent from "@mui/material/DialogContent";
// import DialogContentText from "@mui/material/DialogContentText";
import DialogTitle from "@mui/material/DialogTitle";
import CloseIcon from "@mui/icons-material/Close";
// import FormGroup from "@mui/material/FormGroup";
// End

import Menu from "@mui/material/Menu";
import MenuItem from "@mui/material/MenuItem";

// const label = { inputProps: { "aria-label": "Size switch demo" } };

// For Modal
// import Dialog from "@mui/material/Dialog";
// import DialogActions from "@mui/material/DialogActions";
// import DialogContent from "@mui/material/DialogContent";
// import DialogContentText from "@mui/material/DialogContentText";
// import DialogTitle from "@mui/material/DialogTitle";
// import CloseIcon from "@mui/icons-material/Close";
// End

function ActiveServiceProvidersNewList() {
  const navigate = useNavigate();

  // For memu
  const [anchorEl, setAnchorEl] = React.useState(null);
  const open = Boolean(anchorEl);
  const handleClick = (event) => {
    setAnchorEl(event.currentTarget);
  };
  const handleClose = () => {
    setAnchorEl(null);
  };
  // End

  // For Modal
  const [open2, setOpen] = React.useState(false);
  const [scroll, setScroll] = React.useState("paper");

  const handleClickOpen2 = (scrollType) => () => {
    setOpen(true);
    setScroll(scrollType);
  };

  const handleClose2 = () => {
    setOpen(false);
  };

  const descriptionElementRef = React.useRef(null);
  React.useEffect(() => {
    if (open2) {
      const { current: descriptionElement } = descriptionElementRef;
      if (descriptionElement !== null) {
        descriptionElement.focus();
      }
    }
  }, [open2]);
  // End

  const addCommitee = () => {
    var element = document.getElementById("successfullAdd");
    element.classList.toggle("hideModal");
  };

  return (
    <>
      <Grid container spacing={3} className="mainHeadingLine">
        <Grid item xs={12} md={12}>
          <div className="residentManagementTable">
            <div className="visitorListNewOut"> 
              <div className="visitorListNewInner visitorListNewInnerMain">
                <div className="visitorSearch">
                  <div className="visitorSearchDiv">
                    <SearchIcon className="visitorSearchIco" />
                    <input type="text" placeholder="Search" />
                    <MicIcon className="visitorMicIco" />
                  </div>
                  <SortIcon
                    className="visitorFilterIco"
                    aria-controls={open ? "basic-menu" : undefined}
                    aria-haspopup="true"
                    aria-expanded={open ? "true" : undefined}
                    onClick={handleClick}
                  />
                  <Menu
                    id="basic-menu"
                    anchorEl={anchorEl}
                    open={open}
                    onClose={handleClose}
                    MenuListProps={{
                      "aria-labelledby": "basic-button",
                    }}
                  >
                    <MenuItem onClick={handleClose}>Filter Item 1</MenuItem>
                    <MenuItem onClick={handleClose}>Filter Item 2</MenuItem>
                    <MenuItem onClick={handleClose}>Filter Item 3</MenuItem>
                  </Menu>
                </div>

                <div className="visitContDiv">
                  <div className="visitCont1 resideNewContOut">
                  <div className="servProviderStatus">
                      <span className="activePro showStatus">Active</span>
                      <span className="rejectedPro" >Rejected</span>
                      <span className="VeriInprogress">Verification Inprogress</span>
                      <span className="New">Active</span>
                    </div>
                    <div className="visitContProf">
                      <Zoom>
                        <img src="https://live-production.wcms.abc-cdn.net.au/05861674eec209e9e4b845e31f477dec?impolicy=wcms_crop_resize&cropH=2203&cropW=2203&xPos=0&yPos=0&width=862&height=862" alt="altimage"/>
                      </Zoom>
                    </div>
                    <div className="visitContLeft">
                      <h3
                        className="visitContHed"
                        onClick={() => navigate("/DetailsViewOfServicePro")}
                      >
                        Jerome Bell
                      </h3>
                      <p className="visitContMob">(704) 555-0127</p>
                      <p className="visitContTime">
                        Rewati appt Dr. Richardson Road, <br />
                        Chinchwad 123345
                      </p>
                    </div>
                    <div className="visitBottCont">
                      <p>Service Type</p>
                      <b>Electrical Worker</b>
                    </div>
                    <div className="visitBottCont">
                      <p>Qualification</p>
                      <b>10th class pass</b>
                    </div>
                    <div className="visitBottCont">
                      <p>Entry Time</p>
                      <b>05:51 am</b>
                    </div>
                    <div className="visitBottCont">
                      <p>Exit Time</p>
                      <b>11:49 pm</b>
                    </div>
                    <div className="visitBottCont">
                      <p>Entry Pass</p>
                      <b>
                        <Button
                          className="emtyPassPreview"
                          onClick={handleClickOpen2("body")}
                        >
                          Preview
                        </Button>
                      </b>
                    </div>
                    <div className="resideNewCont">
                      <CreateIcon
                        className="editBt"
                        onClick={() => navigate("/EditServiceProvider")}
                      />
                      <DeleteIcon className="deleteBt" />
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </Grid>
      </Grid>

      <div className="modalMain">
        <Dialog
          open={open2}
          // onClose={handleClose2}
          scroll={scroll}
          aria-labelledby="scroll-dialog-title"
          aria-describedby="scroll-dialog-description"
        >
          <DialogTitle id="scroll-dialog-title" className="modalHeading">
            <span>Entry Pass Preview</span>
            <CloseIcon className="modalCloseBt" onClick={handleClose2} />
          </DialogTitle>
          <DialogContent dividers={scroll === "paper"}>
            <div className="modalInnerCont">
              <div id="successfullAdd">
                <Grid container spacing={3} className="addCommitee1">
                  <Grid item xs={12} md={12}>
                    <div className="entryPassMain entryPassMain2">
                      <div className="entryPassInner">
                        <h4 className="entryParkHeading">
                          Park Side Apartment
                        </h4>
                        <div className="entryPassPro">
                          <Zoom>
                            <img src="https://i.pinimg.com/474x/7f/9d/93/7f9d93408e934aced0f2409656bca021.jpg" alt="altimg"/>
                          </Zoom>
                        </div>
                        <div>
                          <Button className="serviceNameBt">Maid</Button>
                        </div>
                        <div className="entryPassNameNum">
                          <p>Devon Lane</p>
                          <span>(808) 555-0111</span>
                        </div>
                        <div className="entryPassBott">
                          <div className="emtyPssBarOut">
                            <Zoom>
                              <img src="https://upload.wikimedia.org/wikipedia/commons/thumb/4/41/QR_Code_Example.svg/1024px-QR_Code_Example.svg.png" alt="altimg"/>
                            </Zoom>
                          </div>
                          <p>Powered by Resipro</p>
                        </div>
                      </div>
                    </div>
                  </Grid>

                  <Grid item xs={12} md={12}>
                    <div className="modalMainBtMain">
                      <Button className="modalMainBt" onClick={addCommitee}>
                        Print Entry Pass
                      </Button>
                    </div>
                  </Grid>
                </Grid>

                <Grid container spacing={3} className="addCommitee2">
                  <Grid item xs={12} md={12}>
                    <div className="succesMain">
                      <img src="https://encrypted-tbn0.gstatic.com/images?q=tbn:ANd9GcTfz3upZJUzgki4bn27faJf6gPIIo7Yo5HxZg&usqp=CAU" alt="altimg"/>
                      <h4>Success !</h4>
                      <p>Successfully Downloaded</p>
                    </div>
                  </Grid>
                </Grid>
              </div>
            </div>
          </DialogContent>
        </Dialog>
      </div>
    </>
  );
}

export default ActiveServiceProvidersNewList;
